import { render } from "./BusinessCompanyList.vue?vue&type=template&id=50635e8a"
import script from "./BusinessCompanyList.vue?vue&type=script&lang=js"
export * from "./BusinessCompanyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__